import Backbone from 'backbone';

let originalFn = Backbone.history.loadUrl;

Backbone.history.loadUrl = function() {
	Backbone.history.previousFragment = Backbone.history.fragment || '';
	return originalFn.apply(this, arguments);
};